<template>
  <div>
    <el-dialog :title="onAndoffGameData.title" :visible.sync="onAndoffGameData.show" center width="400px">
      <el-form :inline="true" :model="formData" label-width="100px">
        <el-form-item :label="$t('Status')">
          <el-radio-group v-model="formData.State">
            <el-radio :label="1">{{$t('Enable')}}</el-radio>
            <el-radio :label="2">{{$t('deactivate')}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEditRow">{{$t('Confirm2')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  props: {
    onAndoffGameData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: { State: 1 },
    };
  },
  methods: {
    submitEditRow() {
      this.$emit("submitonAndoffGameData", this.formData);
    },
  },
};
</script>
  
  <style  scoped>
</style>